import { connect } from 'react-redux';

import Footer from '../components/shared/footer';

const mapStateToProps = (state, ownProps) => ({
    user: state.user,
    locale: state.locale,
});

const mapDispatchToProps = (dispatch) => ({});

const FooterConnector = connect(mapStateToProps, mapDispatchToProps)(Footer);

export default FooterConnector;



/** WEBPACK FOOTER **
 ** ./src/containers/footer-connector.js
 **/